import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installPerfRum } from "@/lib/perfRum";

installPerfRum();

const root = ReactDOM.createRoot(document.getElementById("root"));
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => {}));
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
